import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Table } from 'grab-ui';
import I18n from 'i18n-js';
import _get from 'lodash/get';
import Driver from 'components/v2/ongoing-bookings-section/table-columns/driver';
import DeliveryStepWithPopup from 'components/v2/ongoing-bookings-section/table-columns/delivery-step';
import { ColumnWithLabel } from 'components/v2/ongoing-bookings-section/table-columns/common';
import PickupTime, {
  pickUpTimeSorter,
} from 'components/v2/ongoing-bookings-section/table-columns/pickup-time';
import { getAmountDisplay, isShopifyOrder } from 'helper/order';
import OrderStatus from 'components/v2/order-status/order-status';
import {
  getUserCountryCodeFromState,
  showInTransitQRCodeSelector,
} from 'selectors/app-selector';
import { connect } from 'react-redux';
import css from './ongoing-bookings-section.less';

const cx = classnames.bind(css);

class OngoingBookingsTable extends Component {
  constructor(props) {
    super(props);
  }

  getColumns = () => {
    const {
      countryCode,
      showInTransitQRCode,
      ongoingOrdersRowActions,
    } = this.props;
    return [
      {
        title: I18n.t('v2.orderTable.column.bookingID'),
        dataIndex: 'steps',
        key: 'bookingCode',
        // width: '15%',
        render: (steps, order) => {
          const main =
            _get(steps, 'length', 0) > 2
              ? _get(order, 'bookingCode')
              : _get(order, 'orderID');
          return (
            <ColumnWithLabel
              label={
                _get(order, 'source') === 2 &&
                I18n.t('v2.orderTable.column.viaGrabMerchant')
              }
            >
              {main}
            </ColumnWithLabel>
          );
        },
      },
      {
        title: I18n.t('v2.orderTable.column.sender'),
        dataIndex: 'steps',
        key: 'sender',
        // width: '10%',
        render: steps => {
          const sender = steps ? steps[0] : {};

          return <DeliveryStepWithPopup isPickUp steps={[sender]} />;
        },
      },
      {
        title: I18n.t('v2.orderTable.column.recipient'),
        dataIndex: 'steps',
        // width: '15%',
        key: 'recipient',
        render: (steps, order) => {
          const recipients = steps ? steps.slice(1) : [];
          const thirdPartySource = _get(order, 'thirdPartySource', null);

          const isShopify = isShopifyOrder(thirdPartySource);
          const shopifyMetaData = isShopify
            ? _get(order, 'shopifyMetaData', [])
            : [];

          return (
            <DeliveryStepWithPopup
              steps={recipients}
              shopifyMetaDatas={shopifyMetaData}
            />
          );
        },
      },
      {
        title: I18n.t('v2.orderTable.column.pickUpTime'),
        dataIndex: 'scheduledPickupSlot',
        key: 'scheduledPickupSlot',
        sorter: pickUpTimeSorter,
        defaultSortOrder: 'ascend',
        // width: '20%',
        render: (scheduledPickupSlot, order) => (
          <PickupTime
            scheduledPickupSlot={scheduledPickupSlot}
            order={order}
            countryCode={countryCode}
          />
        ),
      },
      {
        title: I18n.t('v2.orderTable.column.driver'),
        dataIndex: 'driver',
        key: 'driver',
        // width: '10%',
        render: (driver, order) => (
          <Driver
            driver={driver}
            order={order}
            showInTransitQRCode={showInTransitQRCode}
          />
        ),
      },
      {
        title: I18n.t('v2.orderTable.column.price'),
        dataIndex: 'amount',
        // width: '15%',
        key: 'price',
        render: (amount, order) =>
          order.currency && getAmountDisplay(amount, order.currency, false),
      },
      {
        title: I18n.t('v2.orderTable.column.orderState'),
        key: 'status',
        // width: '20%',
        render: order => <OrderStatus order={order} />,
      },
      {
        title: '',
        key: 'action',
        // width: '5%',
        render: ongoingOrdersRowActions,
      },
    ];
  };

  render() {
    const {
      orders,
      className,
      pagination,
      loading,
      onSelectOrders,
    } = this.props;
    return (
      <Table
        columns={this.getColumns()}
        rowSelection={{ onChange: onSelectOrders }}
        dataSource={orders}
        className={cx('table', className, {
          'table-empty': _isEmpty(orders),
        })}
        pagination={pagination}
        loading={loading}
        rowKey="deliveryID"
      />
    );
  }
}

OngoingBookingsTable.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({})),
  ongoingOrdersRowActions: PropTypes.func.isRequired,
  className: PropTypes.string,
  pagination: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool]),
  loading: PropTypes.bool.isRequired,
  showInTransitQRCode: PropTypes.bool,
  onSelectOrders: PropTypes.func.isRequired,
  countryCode: PropTypes.string.isRequired,
};

OngoingBookingsTable.defaultProps = {
  orders: [],
  columns: null,
  className: '',
  pagination: {},
  showInTransitQRCode: false,
};

export const mapStateToProps = state => ({
  countryCode: getUserCountryCodeFromState(state),
  showInTransitQRCode: showInTransitQRCodeSelector(state),
});

export default connect(mapStateToProps)(OngoingBookingsTable);
